var _symbol, _symbol2, _symbol3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFmTooltipSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "popuptip-close-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84 6L12 11.16L11.16 12L6 6.84L0.84 12L0 11.16L5.16 6L0 0.84L0.84 0L6 5.16L11.16 0L12 0.84L6.84 6Z",
    fill: "#333333"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "tooltip-close-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.005 5.96201L1.636 9.33101L0.751999 8.44701L4.121 5.07801L0.585999 1.54301L1.459 0.669507L4.9945 4.20451L8.53 0.669006L9.414 1.55301L5.8785 5.08851L9.2375 8.44751L8.364 9.32101L5.005 5.96201Z",
    fill: "#333333"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "info-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4303 12C21.4303 6.80014 17.1994 2.5712 12.0008 2.5712C6.80215 2.5712 2.57132 6.80014 2.57132 12C2.57132 17.1983 6.80215 21.4288 12.0008 21.4288C17.1994 21.4288 21.4303 17.1983 21.4303 12ZM23 12C23 18.0742 18.0754 23 12.0008 23C5.92462 23 1 18.0742 1 12C1 5.92585 5.92462 1 12.0008 1C18.0754 1 23 5.92585 23 12ZM12.0008 8.07199C12.6518 8.07199 13.1793 7.54298 13.1793 6.89201C13.1793 6.24104 12.6518 5.71361 12.0008 5.71361C11.3498 5.71361 10.8223 6.24104 10.8223 6.89201C10.8223 7.54298 11.3498 8.07199 12.0008 8.07199ZM12.7862 15.928H14.3575V17.4992H9.64355V15.928H11.2149V11.2144H9.64355V9.64319H12.7862V15.928Z",
    fill: "#0562D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmTooltipSprite);
export default __webpack_public_path__ + "static/media/fm-tooltip-sprite.45d2c188e29ece5324520cb29548c656.svg";
export { ForwardRef as ReactComponent };